import { useContext, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { Routes, ViewerContext } from 'shared'

export const ProtectedRoute = () => {
  const location = useLocation()
  const { viewer, viewerLoading } = useContext(ViewerContext)
  const mustSignUp = !viewerLoading && !!location && !viewer

  // Sign up is server-rendered, so it needs a full page load
  useEffect(() => {
    if (mustSignUp) window.location.replace(Routes.signUpPath({ return_to: location.pathname + location.search }))
  }, [mustSignUp, location])

  if (viewerLoading || !location || !viewer) return null

  return <Outlet />
}
